var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { class: _vm.$style.block }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xl-12" }, [
          _c("div", { class: _vm.$style.inner }, [
            _c(
              "div",
              { class: _vm.$style.loginForm },
              [
                _c("h4", { class: _vm.$style.loginFormTitle }, [
                  _vm._v("\n              2段階認証\n            ")
                ]),
                _c(
                  "a-form",
                  {
                    staticClass: "login-form",
                    attrs: { form: _vm.form },
                    on: { submit: _vm.handleSubmit }
                  },
                  [
                    _c(
                      "a-form-item",
                      { attrs: { label: "コード" } },
                      [
                        _c(
                          "a-input",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "code",
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message: "コードは必須です。"
                                      }
                                    ]
                                  }
                                ],
                                expression:
                                  "['code', { rules: [{ required: true, message: 'コードは必須です。' }]}]"
                              }
                            ],
                            attrs: { placeholder: "code" }
                          },
                          [
                            _c("a-icon", {
                              staticStyle: { color: "rgba(0,0,0,.25)" },
                              attrs: { slot: "prefix", type: "user" },
                              slot: "prefix"
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "pb20" }, [
                      _c(
                        "p",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "pull-right",
                              class: _vm.$style.forgetLink,
                              attrs: { to: "/user/login" }
                            },
                            [_vm._v("戻る")]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "form-actions",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            class: [_vm.$style.filledBtn, _vm.$style.loginBtn],
                            attrs: { htmlType: "submit" }
                          },
                          [_vm._v("ログイン")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }